import React, { useState, useEffect, useRef } from 'react';
import { Badge, Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/items.jpg';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Tooltip, OverlayTrigger, } from "react-bootstrap";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddReceipeNotes = ({ show, onClose, data, onSuccess }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const onInit = () => {
        //   console.log('lightGallery has been initialized'); 
    };

    // fetch unit dropdown
    const [unitOptions, setUnitOptions] = useState([]);
    const fetchActiveUnits = async () => {
        try {
            const response = await axios.get(`${baseURL}/manageunit/list/active`);

            // Assuming response.data.data contains your units array
            const options = response.data.data.map(unit => ({
                value: unit.sno.toString(),          // sno as value (string)
                label: unit.unitslug_name,           // unitslug_name as label
            }));

            setUnitOptions(options);
        } catch (error) {
            console.error('Error fetching active units:', error);
            setUnitOptions([]);
        }
    };
    useEffect(() => {
        fetchActiveUnits();
    }, []);

    // Fetch units by category and set options
    const [options_units, setOptionsUnits] = useState([]);
    const fetchUnitsByCategory = async (categorySno) => {
        try {
            const response = await axios.get(`${baseURL}/manageunit/by-category`, {
                params: { unit_category_sno: categorySno },
            });

            if (response.data.success) {
                const options = response.data.data.map((unit) => ({
                    value: unit.unit_name, // or use unit.sno if you want unique keys
                    label: unit.unitslug_name,
                }));
                setOptionsUnits(options);
            }
        } catch (error) {
            console.error('Error fetching units by category:', error);
            setOptionsUnits([]);
        }
    };
    useEffect(() => {
        fetchUnitsByCategory(1, setUnitOptions); // 4 is unit_category_sno for item_quantity
    }, [baseURL]);

    // fetch preparation category
    const [preparation_category, setPreparationCategory] = useState([]);
    const fetchPreparationCategories = async () => {
        try {
            const response = await axios.get(`${baseURL}/preparation-category/active/list`);
            if (response.data.data) {
                const options = response.data.data.map(category => ({
                    value: category.sno.toString(),              // sno as string value
                    label: category.preparationcategory_name,   // category name as label
                }));
                setPreparationCategory(options);
            }
        } catch (error) {
            console.error('Error fetching preparation categories:', error);
            setPreparationCategory([]);
        }
    };
    useEffect(() => {
        fetchPreparationCategories();
    }, []);

    // fetch temperature
    const [options_temperature, setOptionsTemperature] = useState([]);
    const fetchActiveTemperatures = async () => {
        try {
            const response = await axios.get(`${baseURL}/manage-temperature/active/list`);  // Adjust the endpoint if needed

            // Assuming the response structure is similar and you have 'sno' and 'temperature_name'
            const options = response.data.data.map(temperature => ({
                value: temperature.sno.toString(),    // Assuming 'sno' is unique for each temperature
                label: temperature.temperature_name + ' ' + temperature.unit_name,  // Assuming 'temperature_name' is something like "100°C", "100°F"
            }));

            setOptionsTemperature(options);
        } catch (error) {
            console.error('Error fetching active temperatures:', error);
            setOptionsTemperature([]);
        }
    };
    useEffect(() => {
        fetchActiveTemperatures();
    }, []);

    // fetch duration
    const [options_duration, setOptionsDuration] = useState([]);
    const fetchActiveDurations = async () => {
        try {
            const response = await axios.get(`${baseURL}/duration/active/list`);
            const options = response.data.data.map(duration => ({
                value: duration.sno.toString(),
                label: duration.duration_name + ' ' + duration.unit_name,
            }));
            setOptionsDuration(options);
        } catch (error) {
            console.error('Error fetching active durations:', error);
            setOptionsDuration([]);
        }
    };
    useEffect(() => {
        fetchActiveDurations();
    }, []);

    // Fetch raw materials grouped by category
    const [groupedOptions, setGroupedOptions] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/raw-material-categories-with-materials`)
            .then(response => {
                const categories = response.data.data;

                // Map API data to react-select grouped options format
                const formattedOptions = categories.map(category => ({
                    label: category.category_name,
                    options: category.raw_materials.map(material => ({
                        value: material.sno,                  // sno as value
                        label: material.rawmaterial_name,     // raw material name as label
                        image_url: material.image_url,        // optional if you want to show image
                        brand: material.brand_name,           // optional extra data
                    })),
                }));

                setGroupedOptions(formattedOptions);
            })
            .catch(error => {
                console.error('Error fetching raw material categories:', error);
            });
    }, [baseURL]);

    // yield qty & unit variable
    const [yieldQty, setYieldQty] = useState('');
    const [yieldUnit, setYieldUnit] = useState('');
    const [yunitdisp, setYunitdisp] = useState('');

    // step add more variable
    const [sections, setSections] = useState([
        {
            id: Date.now(),
            preparationCategory: null,
            preparationMethod: '',
            materials: [
                {
                    id: Date.now(),
                    raw_material: null,
                    quantity: '',
                    unit: null,
                    duration: null,
                    temperature: null,
                    isDurationChecked: false,
                    isTemperatureChecked: false,
                }
            ]
        }
    ]);

    const optionsLoaded = preparation_category.length > 0 && groupedOptions.length > 0 && options_units.length > 0 && options_duration.length > 0 && options_temperature.length > 0;

    useEffect(() => {
        if (data && optionsLoaded) {
            axios.get(`${baseURL}/item_recipe/${data.sno}`)
                .then(response => {
                    const recipe = response.data.data.receipe_notes;

                    if (recipe && recipe.process) {

                        // map the receipe in section
                        const mappedSections = recipe.process.map(process => ({
                            id: process.id || Date.now(),
                            preparationCategory: preparation_category.find(option => option.value === process.preparation_category_id.toString()) || null,
                            preparationMethod: process.description || '',
                            materials: process.raw_materials.map(material => ({
                                id: material.id || Date.now(),
                                raw_material: groupedOptions.flatMap(group => group.options).find(opt => opt.value === material.raw_material_id) || null,
                                quantity: material.quantity || '',
                                unit: options_units.find(option => option.value === material.unit_id) || null,
                                duration: material.duration_id ? options_duration.find(option => option.value === material.duration_id.toString()) : null,
                                temperature: material.temperature_id ? options_temperature.find(option => option.value === material.temperature_id.toString()) : null,
                                isDurationChecked: material.duration_id !== null,
                                isTemperatureChecked: material.temperature_id !== null,
                            })),
                        }));

                        setSections(mappedSections);
                        setYieldQty(recipe.yield);
                        setYunitdisp(unitOptions.find(option => option.value === recipe.unit.toString()) || null);
                        setYieldUnit(recipe.unit);
                    } else {
                        setYieldQty(data.catering_corp_quantity);
                        let unt = unitOptions.find(itm => Number(itm.value) === data.catering_corp_unit);
                        setYunitdisp(unt);
                        setYieldUnit(unt.value);
                    }
                })
                .catch(error => {
                    console.log('Error fetching recipe:', error);
                });
        }
    }, [data, optionsLoaded]);


    const handleAddRawMaterial = (sectionIndex) => {
        const updatedSections = [...sections];
        updatedSections[sectionIndex].materials.push({
            id: Date.now(),
            raw_material: null,
            quantity: '',
            unit: null,
            duration: null,
            temperature: null,
            isDurationChecked: false,
            isTemperatureChecked: false,
        });
        setSections(updatedSections);
    };

    const handleAddFullSection = () => {
        setSections([
            ...sections,
            {
                id: Date.now(),
                preparationCategory: null,
                preparationMethod: '',
                materials: [
                    {
                        id: Date.now(),
                        raw_material: null,
                        quantity: '',
                        unit: null,
                        duration: null,
                        temperature: null,
                        isDurationChecked: false,
                        isTemperatureChecked: false,
                    }
                ]
            }
        ]);
    };

    const handleDeleteRawMaterial = (sectionIndex, materialIndex) => {
        const updated = [...sections];
        updated[sectionIndex].materials.splice(materialIndex, 1);
        if (updated[sectionIndex].materials.length === 0) {
            updated[sectionIndex].materials.push({
                id: Date.now(),
                selectedOption: null,
                quantity: '',
                unit: null
            });
        }
        setSections(updated);
    };

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };

    const handleDeleteSection = (sectionIndex) => {
        const updated = [...sections];
        updated.splice(sectionIndex, 1);
        setSections(updated);
    };

    const generatePayload = (sections, yieldQuantity, yieldUnitId) => {
        const process = sections.map(section => {
            return {
                preparation_category: section.preparationCategory ? parseInt(section.preparationCategory.value) : null,  // Assuming selected option has `value`
                description: section.preparationMethod || "",
                raw_materials: section.materials.map(material => ({
                    raw_material: material.raw_material ? parseInt(material.raw_material.value) : null, // Selected material from dropdown
                    quantity: parseFloat(material.quantity) || 0,
                    unit: material.unit ? parseInt(material.unit.value) : null, // Assuming `unit` is a Select object with { label, value }
                    duration: material.duration ? parseInt(material.duration.value) : null,
                    temperature: material.temperature ? parseInt(material.temperature.value) : null,
                }))
            };
        });

        const payload = {
            recipe_notes: {
                yield: parseFloat(yieldQuantity),     // From your form input
                unit: yieldUnitId,                    // Selected yield unit ID
                process
            }
        };

        return payload;
    };

    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};

        if (!yieldQty) {
            newErrors.yqty = "This Field is Required.";
        }

        if (!yieldUnit) {
            newErrors.yqty = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = generatePayload(sections, yieldQty, yieldUnit); // formYieldQty and formYieldUnitId from inputs
        console.log("Payload: ", payload);

        axios.post(`${baseURL}/items_add_recipe/${data.sno}`, payload)
            .then(response => {
                toast.success("Receipe Notes Created Successfully!");
                if (onSuccess) onSuccess();
                onClose();
                // onClose();
                // refresh();
                // toast.success("Recipe Notes Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Recipe Notes Creation Failed");
            });
    };

    return (
        <Modal show={show} size="xl">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">
                        Recipe Notes
                    </h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* item details */}
                    <div className="row mb-3">
                        {/* item details */}
                        <div className="col-lg-8">
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]} >
                                    <div data-src={data.item_image || idly} className='border rounded px-1 py-0'>
                                        <img src={data.item_image || idly} alt="Podi Idly" className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div>
                                    <label className='text-black font-w400 fs-5'>{data.item_name}</label>
                                    <div className='d-block'>
                                        <label className='text-black font-w400 fs-6'>{data.itemsubcategory_name}</label>
                                        <label className='text-black me-2 ms-2'>|</label>
                                        <label className='text-black font-w400 fs-6'>{data.itemcategory_name}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* yield Quantity */}
                        <div className="col-lg-4">
                            <label className="text-black font-w500 fs-7">Yield (Quantity)<span className="required">*</span></label>
                            <div className='row'>
                                <div className='col-lg-6 pe-1'>
                                    <input type="text" className="form-control" placeholder="Enter Qty"
                                        maxLength={10}
                                        value={yieldQty}
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                            setYieldQty(onlyNums);
                                        }}
                                    />
                                </div>
                                <div className='col-lg-6 pe-1'>
                                    <Select
                                        placeholder="Select Unit"
                                        options={unitOptions}
                                        value={yunitdisp}
                                        onChange={(e) => {
                                            setYunitdisp(e);
                                            setYieldUnit(parseInt(e.value));
                                        }}
                                        menuPlacement="top"
                                        menuPosition="fixed"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        }}
                                    />
                                </div>
                                {errors.yqty && <div className="text-danger fs-8 mt-1">{errors.yqty}</div>}
                            </div>
                        </div>
                    </div>

                    {/* add more content */}
                    <div className='row mb-2'>
                        <div className='scroll-y mh-425px py-2'>
                            <div className="col-lg-12 mb-3">
                                <div className="mb-0">

                                    {/* step addmore */}
                                    <>
                                        {sections.map((section, sectionIndex) => (
                                            <div key={sectionIndex}>
                                                <div key={section.id} className="border rounded p-3 mb-3">
                                                    <h4 className="text-danger mb-3">Step {sectionIndex + 1}</h4>

                                                    {/* preparation category */}
                                                    <div className="col-lg-4 pe-1 mb-2">
                                                        <label className="text-black font-w500 fs-7">Preparation Category<span className="required">*</span></label>

                                                        <Select
                                                            placeholder="Select Preparation Category"
                                                            value={section.preparationCategory}
                                                            onChange={(selected) => {
                                                                const updated = [...sections];
                                                                updated[sectionIndex].preparationCategory = selected;
                                                                setSections(updated);
                                                            }}
                                                            options={preparation_category}
                                                        />

                                                    </div>

                                                    {/* raw material add more */}

                                                    {section.materials.map((material, materialIndex) => (
                                                        <div key={material.id} className="row mb-2">

                                                            {/* raw material */}
                                                            <div className="col-lg-3 pe-1">
                                                                <label className="text-black font-w500 fs-7">Raw Material <span className="required">*</span></label>

                                                                <Select
                                                                    placeholder="Select Raw Material"
                                                                    components={{ Group }}
                                                                    value={material.raw_material}
                                                                    onChange={(selected) => {
                                                                        const updated = [...sections];
                                                                        updated[sectionIndex].materials[materialIndex].raw_material = selected;
                                                                        setSections(updated);
                                                                    }}
                                                                    options={groupedOptions}
                                                                    styles={{
                                                                        ...customStyles,
                                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                />

                                                            </div>

                                                            {/* quantity */}
                                                            <div className="col-lg-2 pe-1">
                                                                <label className="text-black font-w500 fs-7">Quantity <span className="required">*</span></label>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Qty"
                                                                    value={material.quantity}
                                                                    onChange={(e) => {
                                                                        const updated = [...sections];
                                                                        updated[sectionIndex].materials[materialIndex].quantity = e.target.value;
                                                                        setSections(updated);
                                                                    }}
                                                                />

                                                            </div>

                                                            {/* unit */}
                                                            <div className="col-lg-2 pe-1">
                                                                <label className="text-black font-w500 fs-7">Units <span className="required">*</span></label>

                                                                <Select
                                                                    placeholder="Units"
                                                                    value={material.unit}
                                                                    onChange={(selected) => {
                                                                        const updated = [...sections];
                                                                        updated[sectionIndex].materials[materialIndex].unit = selected;
                                                                        setSections(updated);
                                                                    }}
                                                                    options={options_units}
                                                                />
                                                            </div>

                                                            {/* duration */}
                                                            <div className="col-lg-2 pe-1">

                                                                <label className="text-black font-w500 fs-7">

                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input me-2 mb-1"
                                                                        checked={material.isDurationChecked}
                                                                        onChange={(e) => {
                                                                            const updated = [...sections];
                                                                            updated[sectionIndex].materials[materialIndex].isDurationChecked = e.target.checked;
                                                                            if (!e.target.checked) {
                                                                                updated[sectionIndex].materials[materialIndex].duration = null;
                                                                            }
                                                                            setSections(updated);
                                                                        }}
                                                                    />
                                                                    Duration
                                                                    {material.isDurationChecked && (<span className="required">*</span>)}
                                                                </label>

                                                                {material.isDurationChecked && (
                                                                    <Select
                                                                        value={material.duration}
                                                                        onChange={(selected) => {
                                                                            const updated = [...sections];
                                                                            updated[sectionIndex].materials[materialIndex].duration = selected;
                                                                            setSections(updated);
                                                                        }}
                                                                        options={options_duration}
                                                                    />
                                                                )}

                                                            </div>

                                                            {/* temperature */}
                                                            <div className="col-lg-2 pe-1">

                                                                <label className="text-black font-w500 fs-7">

                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input me-2 mb-1"
                                                                        checked={material.isTemperatureChecked}
                                                                        onChange={(e) => {
                                                                            const updated = [...sections];
                                                                            updated[sectionIndex].materials[materialIndex].isTemperatureChecked = e.target.checked;

                                                                            // If unchecked, clear the value
                                                                            if (!e.target.checked) {
                                                                                updated[sectionIndex].materials[materialIndex].temperature = null;
                                                                            }

                                                                            setSections(updated);
                                                                        }}
                                                                    />
                                                                    Temperature
                                                                    {material.isTemperatureChecked && (<span className="required">*</span>)}
                                                                </label>

                                                                {material.isTemperatureChecked && (
                                                                    <Select
                                                                        placeholder="Select Temperature"
                                                                        value={material.temperature}
                                                                        onChange={(selected) => {
                                                                            const updated = [...sections];
                                                                            updated[sectionIndex].materials[materialIndex].temperature = selected;
                                                                            setSections(updated);
                                                                        }}
                                                                        options={options_temperature} // Your options array
                                                                        styles={{
                                                                            ...customStyles,
                                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                        }}
                                                                        menuPortalTarget={document.body}
                                                                        menuPosition="fixed"
                                                                    />
                                                                )}

                                                            </div>

                                                            {/* delete raw material */}
                                                            <div className=" col-lg-1 d-flex align-items-center mt-4">
                                                                {section.materials.length > 1 && (
                                                                    <button
                                                                        className="btn btn-danger btn-sm px-2"
                                                                        onClick={() => handleDeleteRawMaterial(sectionIndex, materialIndex)}
                                                                    >
                                                                        <i className="fa-solid fa-trash-can"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {/* raw material add more */}
                                                    <div className=" mb-3  d-flex align-items-end justify-content-start mt-4">
                                                        <button
                                                            className="btn btn-sm btn-primary py-1 px-2"
                                                            onClick={() => handleAddRawMaterial(sectionIndex)}
                                                        >
                                                            <i className="fa-solid fa-plus me-2"></i><span className='fs-8'>Raw Material</span>
                                                        </button>
                                                    </div>

                                                    {/* description & delete step */}
                                                    <div className='row'>

                                                        {/* description */}
                                                        <div className="col-lg-10 mt-2">
                                                            <label className="text-black font-w500 fs-7">Description<span className="required">*</span></label>

                                                            <textarea
                                                                rows={8}
                                                                className="form-control"
                                                                placeholder="Enter Description"
                                                                value={section.preparationMethod}
                                                                onChange={(e) => {
                                                                    const updated = [...sections];
                                                                    updated[sectionIndex].preparationMethod = e.target.value;
                                                                    setSections(updated);
                                                                }}
                                                            />

                                                        </div>

                                                        {/* delete step */}
                                                        <div className="col-lg-2 d-flex align-items-center mt-4">
                                                            {sections.length > 1 && (
                                                                <div className="mt-3 text-end">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete Step</span></Tooltip>} >
                                                                        <button
                                                                            className="btn btn-danger btn-sm px-2"
                                                                            onClick={() => handleDeleteSection(sectionIndex)}
                                                                        >
                                                                            <i className="fa-solid fa-trash-can"></i>
                                                                        </button>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>

                                </div>
                            </div>
                        </div>
                        <div className="mt-2 mb-4">
                            <button className="btn btn-primary btn-sm py-1 px-2" onClick={handleAddFullSection}>
                                <i className="fa-solid fa-plus me-2"></i>Add More
                            </button>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Receipe Notes  <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddReceipeNotes;
